export const geoControl = {
    enabled: false,
    _description: 'Enables the geo control feature on bank card settings page',
};
